
<button mat-raised-button (click)="doTransfers()">Do Transfers</button>